<div class="grid grid-cols-2 mb-4 header">
    <sl-label size="large" line-height="small" i18n>People</sl-label>
    <span class="text-right">
        <sl-button size="small" type="primary" (click)="showModal()" i18n>Invite member</sl-button>
    </span>
</div>

<sl-alert class="mt-4" type="info" open>
    <span i18n>Manage the members of your organization.</span>&nbsp;
    <a href="https://docs.previsto.com/help/integration-til-previsto/api-keys" target="_BLANK" i18n>Learn more.</a></sl-alert>
    

<sl-list class="mt-4" lines="full">
    <sl-list *ngIf="!initialized">
        <sl-skeleton class="m-6" effect="sheen"></sl-skeleton>
    </sl-list>

    <ng-container *ngIf="initialized">
        <sl-list-item *ngFor="let invitation of invitations" [value]="invitation.id">
            <sl-label i18n>Invitation for {{invitation.email}}</sl-label>
            <sl-label color="dark" size="small" i18n>Expires {{invitation.expireDate | date:'shortDate'}}</sl-label>
            <sl-button slot="suffix" size="small" (click)="cancelInvitation(invitation)" i18n>Cancel invitation</sl-button>
        </sl-list-item>
        
        <sl-list-item *ngFor="let account of accounts" (click)="viewUser(account)">
            <sl-label>{{account.name}} <span *ngIf="account.name !== account.email" class="email">– {{account.email}}</span></sl-label>
            <sl-label color="dark" size="small" *ngIf="isAdmin(account)" i18n="@@Administrator">Administrator</sl-label>
            <sl-label color="dark" size="small" *ngIf="isManager(account)" i18n="@@Manager">Manager</sl-label>
            <sl-label color="dark" size="small" *ngIf="isTrustedEmployee(account)" i18n="@@User">Trusted Employee</sl-label>
            <sl-label color="dark" size="small" *ngIf="isEmployee(account)" i18n="@@Employee">Employee</sl-label>
            
            <sl-icon slot="suffix" name="shield" (click)="editSecurity($event, account)"></sl-icon>
        </sl-list-item>
    </ng-container>
</sl-list>
